import type { AssistantMessage } from '../core/wire';
import { StateView } from './StateView';
import { traceLines } from './trace';
import { turnStateOf } from './turn-state';
import css from './TraceView.module.css';

export { replyChips } from './trace';

/** What a reply shows of itself: the steps of its turn, the state the turn left. */
export type TracePart = 'steps' | 'state';

/** The trace of one answer: the steps, then the state after the turn (docs/NEW-UI/07 D-09). */
export function TraceView({ message, theme = 'light', parts = ['steps', 'state'] }: {
  message: AssistantMessage;
  theme?: 'light' | 'dark';
  parts?: readonly TracePart[];
}) {
  const lines = traceLines(message);
  const state = parts.includes('state') ? turnStateOf(message) : null;
  return (
    <div className={`${css.trace} ${theme === 'dark' ? css.dark : ''}`}>
      {parts.includes('steps') && (
        <ol className={css.steps}>
          {lines.map((l, i) => (
            <li key={i} className={css.step} data-stage={l.stage}>
              <strong>{l.title}</strong>
              {l.details.map((d, j) => <code key={j}>{d}</code>)}
            </li>
          ))}
          {lines.length === 0 && <li className={css.step}>no trace</li>}
        </ol>
      )}
      {state && <StateView state={state} />}
    </div>
  );
}
